import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Button, Modal, Image, Form } from "react-bootstrap";
import { get } from "lodash";
import {
  getSearchInputData,
  resetSearchInputData
} from "../../../actions/common.action";
import {
  clearUsersListDownloadAction,
  deleteGroupAction,
  getDownloadUsersListAction,
  getGroupsForUserAction,
  getGroupsListAction,
  getIIGDraftUsersListAction,
  migrateProjectAction
} from "../../../actions/userManagement.action";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { LoaderPage } from "../../../component/Loader";
import { PopUpModel } from "../../../component/PopUp";
import { STATUS, GROUP_ROLE } from "../../../constant";
import { isValidArray } from "../../../helper";
import Pagination from "../../Pagination";
import PermissionHOC from "../../PermissionHOC";
import {
  DownloadExcelReport,
  ModalComponent,
  ModalTemplate,
  Search,
  TableTemplate
} from "../../reusableComponent";
import { PAGE_COUNT } from "../helper";
import { userListHeaderOptions as headerOptions } from "../usermangement.constant";
import CreateUserForm from "./createUser.Form";
import CreateUserEditForm from "./createUserEdit.Form";
import { MigrateProjectComponent } from "./migrateProjectComponent";
import MigratePeople from "../../../assets/migrate.svg";
import CreateUser from "../../../assets/create-user-icon.svg";
import NodalOfficer from "../../../assets/nodal.svg";
import EditImage from "../../../assets/edit-image.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import GroupManagementSidebar from "../../GroupManagement/GroupManagementSidebar";
import { successToastStyle, errorToastStyle } from "../../../customToast";

const Params = {
  limit: 10,
  offset: 0,
  search: "",
  groupId: "",
  active: true
};

class CreateIIGUserListing extends Component {
  state = {
    paginationoffset: 0,
    filteredArray: [],
    noFilterData: false,
    searchInputData: "",
    showBubbleFilter: false,
    selectedFilter: null,
    makeSelectedNull: false,
    usersListParams: { ...Params },
    isUserActive: true,
    displayModal: false
  };

  componentDidMount() {
    const { getUsersListDispatch, getGroupsForUserAction } = this.props;
    const { usersListParams } = this.state;
    getUsersListDispatch(undefined, usersListParams);
    getGroupsForUserAction(undefined);
  }

  componentWillUnmount() {
    const { resetSearchInputData } = this.props;
    resetSearchInputData();
  }

  onToggleModal = value => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = value => {
    const isEdit = this.state.isEdit;
    this.setState({
      isEdit: !isEdit,
      groupData: (!isEdit && value) || null
    });
  };

  onDeleteAlertToggle = value => {
    const displayDeleteAlert = this.state.displayDeleteAlert;
    this.setState({
      displayDeleteAlert: !displayDeleteAlert,
      deleteData: (!displayDeleteAlert && value) || null
    });
  };

  onDelete = async value => {
    const { deleteGroupDispatch, getGroupsListDispatch } = this.props;
    const { deleteData } = this.state;
    const response = await deleteGroupDispatch(undefined, {
      groupID: get(deleteData, "id", -1)
    });
    if (response) {
      const { status, message } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && getGroupsListDispatch(undefined);
    } else {
      toast.error(
        <p className="toast-text-alignment">Please try again</p>,
        errorToastStyle
      );
    }
  };

  getFilterId = (id, elem) => {
    const { getUsersListDispatch } = this.props;

    if (id === 0) {
      this.removeFilter();
    } else {
      this.setState(
        prevState => ({
          paginationoffset: 0,
          showBubbleFilter: true,
          selectedFilter: elem,
          makeSelectedNull: false,
          usersListParams: {
            ...prevState.usersListParams,
            offset: 0,
            groupId: id
            //search:""
          }
        }),
        () => {
          getUsersListDispatch(undefined, this.state.usersListParams);
        }
      );
    }
  };

  removeFilter = () => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: 0,
        showBubbleFilter: false,
        selectedFilter: null,
        makeSelectedNull: true,
        usersListParams: {
          ...prevState.usersListParams,
          offset: 0,
          groupId: ""
        }
      }),
      () => {
        getUsersListDispatch(undefined, this.state.usersListParams);
      }
    );
  };

  onPageChange = page => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: page.selected || 0,
        usersListParams: {
          ...prevState.usersListParams,
          offset: page.selected || 0,
          limit: PAGE_COUNT
        }
      }),
      () => {
        getUsersListDispatch(undefined, this.state.usersListParams);
      }
    );
  };

  callApiOnSuccess = () => {
    // this.removeFilter();

    const { getUsersListDispatch } = this.props;
    getUsersListDispatch(undefined, this.state.usersListParams);
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      usersListParams: {
        ...prevState.usersListParams,
        offset: 0,
        [name]: value
      }
    }));
  };

  callAfterDebounce = () => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      {
        isSearching: true
      },
      async () => {
        await getUsersListDispatch(undefined, this.state.usersListParams);
        this.setState({
          isSearching: false
        });
      }
    );
  };

  onToggleMigrateModal = () => {
    this.setState(prevState => ({
      toggleMigrateModal: !prevState.toggleMigrateModal
    }));
  };

  //  on migrate project
  onSubmitMigrateProject = async () => {
    try {
      const {
        migrateProjectAction,
        getUsersListDispatch,
        migrateFormData: {
          projectList = [],
          sourceUserID = null,
          targetUserID = null
        }
      } = this.props;
      // invalid key
      let invalidKey = "";

      // if source id not selected
      if (!sourceUserID) {
        return toast.error(
          <p className="toast-text-alignment">From User must be selected</p>,
          errorToastStyle
        );
      }

      // if target is not selected
      if (!targetUserID) {
        return toast.error(
          <p className="toast-text-alignment">To User must be selected</p>,
          errorToastStyle
        );
      }

      // both user id is equal
      if (sourceUserID && targetUserID && sourceUserID.id === targetUserID.id) {
        return toast.error(
          <p className="toast-text-alignment">
            You cannot assign projects to the same user.
          </p>,
          errorToastStyle
        );
      }

      // if not a single project is selected
      if (!projectList.filter(val => val.checked).length) {
        return toast.error(
          <p className="toast-text-alignment">
            Any one project must be selected
          </p>,
          errorToastStyle
        );
      }

      // submit migrate user
      await migrateProjectAction(undefined, {
        projectIds: projectList.filter(val => val.checked).map(val => val.id),
        targetId: targetUserID && targetUserID.id,
        fromId: sourceUserID && sourceUserID.id
      });
      // close the modal
      this.onToggleMigrateModal();
      await getUsersListDispatch(undefined, this.state.usersListParams);
    } catch (e) {
      console.error(e);
    }
  };

  onUsersListDownload = async () => {
    const { usersListParams } = this.state;
    const { getDownloadUsersListAction } = this.props;
    await getDownloadUsersListAction(undefined, usersListParams);
  };

  handleCheckbox = () => {
    const { isUserActive } = this.state;
    this.setState(
      {
        isUserActive: !isUserActive
      },
      () => {
        this.userListApiCalling();
      }
    );
  };
  userListApiCalling = () => {
    const { getUsersListDispatch } = this.props;
    const { isUserActive } = this.state;
    try {
      if (isUserActive === true) {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: true
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      } else {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: false
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
  onClearDownload = () => {
    const { clearUsersListDownloadAction } = this.props;
    clearUsersListDownloadAction();
  };

  render() {
    const {
      onSearch,
      callAfterDebounce,
      onToggleMigrateModal,
      onSubmitMigrateProject,
      onClearDownload,
      onUsersListDownload
    } = this;

    const {
      groups,
      usersListing,
      isUserListLoading,
      getSearchInputData,
      permission,
      isProjectMigrating,
      usersListDownload
    } = this.props;
    const {
      displayModal,
      isEdit,
      groupData,
      displayDeleteAlert,
      noFilterData,
      filteredArray,
      isFilterApplied,
      usersListParams,
      isSearching,
      toggleMigrateModal,
      paginationoffset,
      showBubbleFilter,
      selectedFilter,
      makeSelectedNull,
      isUserActive
    } = this.state;
    if (isValidArray(get(usersListing, "data.userDTOList"))) {
      const listData = usersListing.data.userDTOList;
      let groupList = isFilterApplied ? filteredArray : listData;
      if (usersListParams.search) {
        groupList = [];
        listData.forEach(group => {
          if (
            group.name
              .toLowerCase()
              .includes(usersListParams.search.toLowerCase())
          ) {
            groupList.push(group);
          }
        });
      }
    }
    //Filter list based on category
    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(get(groups, "data"))) {
      groups.data.forEach(elem => {
        filterList.push(elem);
      });
    }
    return (
      <div className="group-management users-listing draft-users-listing">
        <LoaderPage loading={isProjectMigrating} />
        {toggleMigrateModal ? (
          <ModalComponent
            centered
            classes="migrate_modal"
            onClose={onToggleMigrateModal}
            size={"lg"}
            template={
              <ModalTemplate
                bodyTemplate={<MigrateProjectComponent />}
                onClose={onToggleMigrateModal}
                onSubmitTitle="Migrate"
                onSubmit={onSubmitMigrateProject}
              />
            }
          />
        ) : null}

        <div className="header ">
          <div className="d-flex flex-row">
            <h3>
              Draft User{" "}
              {(get(usersListing, "data.count") && (
                <span>({get(usersListing, "data.count")})</span>
              )) ||
                null}
            </h3>
          </div>
        </div>
        {/*  Edit Modal Start **/}

        <Modal
          size="lg"
          show={isEdit}
          onHide={this.onEdit}
          aria-labelledby="example-modal-sizes-title-lg"
          containerClass="edit-user-form"
          className="edit-user-modal-form"
        >
          <div className="modal-box-shadow">
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                Edit User
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal  create-edit-body-modal">
              <CreateUserEditForm
                togglePopUp={this.onEdit}
                isEdit={isEdit}
                groupData={groupData}
                callApiOnSuccess={this.callApiOnSuccess}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Edit Modal End **/}

        {/*  Create Modal **/}
        <Modal
          size="lg"
          show={displayModal}
          onHide={this.onToggleModal}
          aria-labelledby="example-modal-sizes-title-lg"
          className="content-modal  create-user-form"
        >
          <div className="modal-box-shadow">
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                Create User
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal  create-user-body-modal">
              <CreateUserForm
                togglePopUp={this.onToggleModal}
                callApiOnSuccess={this.callApiOnSuccess}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Create Modal End **/}

        {/*  Delete Alert Pop Up **/}

        <PopUpModel
          open={displayDeleteAlert}
          text={"Are you sure you want to delete it?"}
          leftBtnText={"Yes"}
          rightBtnText={"No"}
          onCancel={this.onDeleteAlertToggle}
          onSubmit={this.onDelete}
        />
        {showBubbleFilter ? (
          <div className="applied-filter-list pt-3 mb-0">
            <div className="applied-filter mb-0">
              {selectedFilter && selectedFilter.name}
              <span
                className="close"
                onClick={e => {
                  this.removeFilter();
                }}
              >
                X
              </span>
            </div>
          </div>
        ) : null}
        <TableTemplate
          isUsersTable={true}
          headersOptions={headerOptions}
          isLoading={isUserListLoading === STATUS.LOADING}
          bodyOptions={get(usersListing, "data.userDTOList")}
          bodyTemplate={(options, index) => (
            <>
              <td>
                {index + 1 + usersListParams.offset * usersListParams.limit}
              </td>
              <td
                className={`${
                  options.groupRoles !== null &&
                  (options.groupRoles.includes(
                    GROUP_ROLE.CENTRAL_NODAL_OFFICER
                  ) ||
                    options.groupRoles.includes(
                      GROUP_ROLE.CENTRAL_DEPARTMENT_NODAL_OFFICER
                    ) ||
                    options.groupRoles.includes(
                      GROUP_ROLE.STATE_DEPARTMENT_NODAL_OFFICER
                    ) ||
                    options.groupRoles.includes(
                      GROUP_ROLE.STATE_NODAL_OFFICER
                    )) === true
                    ? "pl-2"
                    : ""
                }`}
              >
                <div className="d-flex align-items-center">
                  <div>
                    {options.groupRoles !== null ? (
                      (options.groupRoles.includes(
                        GROUP_ROLE.CENTRAL_NODAL_OFFICER
                      ) ||
                        options.groupRoles.includes(
                          GROUP_ROLE.CENTRAL_DEPARTMENT_NODAL_OFFICER
                        ) ||
                        options.groupRoles.includes(
                          GROUP_ROLE.STATE_DEPARTMENT_NODAL_OFFICER
                        ) ||
                        options.groupRoles.includes(
                          GROUP_ROLE.STATE_NODAL_OFFICER
                        )) === true ? (
                        <OverlayTrigger
                          defaultShow={false}
                          placement="bottom"
                          overlay={
                            <Tooltip
                              id={`tooltip-checking`}
                              className="create_project_tolltip"
                            >
                              Nodal
                            </Tooltip>
                          }
                        >
                          <Image
                            src={NodalOfficer}
                            className="nodal-officer-icon"
                          />
                        </OverlayTrigger>
                      ) : (
                        <></>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="pl-2">{options.name}</div>
                </div>
              </td>
              <td>{options.groupOrganization}</td>
              <td>{options.active ? "Yes" : "No"}</td>
              <td>
                {get(permission, "updateUser") ? (
                  <Image
                    className="edit-image"
                    src={EditImage}
                    onClick={this.onEdit.bind(this, options)}
                  />
                ) : null}
              </td>
            </>
          )}
          headersTemplate={options => (
            <>
              <th>{options.title}</th>
            </>
          )}
        />

        {isUserListLoading === STATUS.SUCCESS ? (
          <div className="pagination-wrapper">
            <div class="pagination pagination-in-user-listing">
              <Pagination
                offset={paginationoffset}
                pageCount={get(usersListing, "data.count") / PAGE_COUNT}
                onPageChange={this.onPageChange}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    usersListing: state.userManagementReducer.usersListing,
    groups: state.userManagementReducer.groups,
    isUserListLoading: state.userManagementReducer.isUserListLoading,
    searchInput: state.commonReducer.searchInput,
    migrateFormData: state.userManagementReducer.migrateFormData,
    isProjectMigrating: state.userManagementReducer.isProjectMigrating,
    usersListDownload: state.userManagementReducer.usersListDownload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getGroupsListDispatch: getGroupsListAction,
      deleteGroupDispatch: deleteGroupAction,
      getUsersListDispatch: getIIGDraftUsersListAction,
      getSearchInputData: getSearchInputData,
      resetSearchInputData: resetSearchInputData,
      migrateProjectAction: migrateProjectAction,
      getGroupsForUserAction,
      getDownloadUsersListAction,
      clearUsersListDownloadAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(CreateIIGUserListing));
